import {
  ContentState,
  convertFromHTML,
  convertToRaw,
} from 'draft-js'
import flattenDeep from 'lodash/flattenDeep'
import type {
  ButtonElement,
  CampaignSection,
  CampaignSectionColumn,
  DividerElement,
  EmailElement,
  ImageElement,
  PlaylistElement,
  TextElement,
} from 'types/content-editor'
export const getTextBlock = (htmlContent: string): TextElement => {
  const blocks = convertFromHTML(htmlContent)
  const contentState = ContentState.createFromBlockArray(
    blocks.contentBlocks,
    blocks.entityMap,
  )
  const content = convertToRaw(contentState)
  return {
    type: 'text',
    content,
    htmlContent,
  }
}
export const getImageBlock = (src: string): ImageElement => ({
  type: 'image',
  src,
})
export const getPlaylistBlock = (): PlaylistElement => ({
  type: 'playlist',
  playlist_id: null,
  buttonText: 'Open playlist',
})
export const getButtonBlock = (
  caption: string,
  link: string,
  backgroundColor: string,
  color: string,
): ButtonElement => ({
  type: 'button',
  link,
  caption,
  style: {
    backgroundColor,
    color,
  },
  playlist_id: null,
})
export const getImageAndTextBlock = (
  image: string,
  htmlContent: string,
): [ImageElement, TextElement] => {
  return [getImageBlock(image), getTextBlock(htmlContent)]
}
export const getSectionBlock = (
  columns: CampaignSectionColumn[],
): CampaignSection => {
  return {
    columns,
  }
}
export const getColumnBlock = (
  columnContent: EmailElement[],
): CampaignSectionColumn => {
  return {
    columnContent,
  }
}
export const getEmailBlocks = (campaign: CampaignSection[]): EmailElement[] => {
  const blocks = flattenDeep(
    campaign.map(section =>
      section.columns.map(column => column.columnContent || []),
    ),
  )
  return blocks
}
export const getCampaignPlaylistIds = (campaign: CampaignSection[]): any => {
  return campaign
    ? getEmailBlocks(campaign)
        .filter(
          b => b.type === 'playlist' && 'playlist_id' in b && b.playlist_id,
        )
        .map(b => ('playlist_id' in b ? b.playlist_id : null))
        .filter(Boolean)
    : []
}
export const getDividerBlock = (
  borderWidth: string,
  borderColor: string,
  borderStyle: 'dotted' | 'dashed' | 'solid',
  padding: string,
): DividerElement => ({
  type: 'divider',
  borderWidth,
  borderColor,
  borderStyle,
  padding,
})
